﻿import { Page } from '@shopify/polaris'
import { ProductCopyGenerator } from '@/components/copywriter/ProductCopyGenerator'

export function CopywriterPage() {
  return (
    <Page fullWidth title="AI Copywriter" subtitle="Generate SEO-optimised product titles and descriptions">
      <ProductCopyGenerator />
    </Page>
  )
}
